import React from 'react';

const BenchmarkComparison = ({ displayData, sampleDataFallback }) => (
  <div className="space-y-6">
    <div className="flex items-center justify-between">
      <h2 className="text-2xl font-bold text-slate-800 dark:text-white">
        📊 Industry Benchmark Comparison
      </h2>
      <span className="bg-purple-100 dark:bg-purple-900/40 text-purple-800 dark:text-purple-300 px-3 py-1 rounded-full text-sm font-medium">
        Premium Feature
      </span>
    </div>

    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-lg font-semibold mb-6 text-gray-800 dark:text-white">
        Energy Performance Comparison
      </h3>

      <div className="space-y-4">
        {/* Your Facility */}
        <div className="flex items-center">
          <div className="w-32 text-sm font-medium text-gray-700 dark:text-gray-300">
            Your Facility
          </div>
          <div className="flex-1 bg-gray-200 dark:bg-gray-700 rounded-full h-8 relative">
            <div
              className="bg-emerald-500 dark:bg-emerald-400 h-8 rounded-full flex items-center justify-end pr-3"
              style={{
                width: `${
                  (sampleDataFallback.facilityScore /
                    sampleDataFallback.topQuartile) *
                  100
                }%`
              }}
            >
              <span className="text-white font-bold text-sm">
                {sampleDataFallback.facilityScore}%
              </span>
            </div>
          </div>
        </div>

        {/* Industry Average */}
        <div className="flex items-center">
          <div className="w-32 text-sm font-medium text-gray-700 dark:text-gray-300">
            Industry Avg
          </div>
          <div className="flex-1 bg-gray-200 dark:bg-gray-700 rounded-full h-8 relative">
            <div
              className="bg-blue-500 dark:bg-blue-400 h-8 rounded-full flex items-center justify-end pr-3"
              style={{
                width: `${
                  (sampleDataFallback.industryAverage /
                    sampleDataFallback.topQuartile) *
                  100
                }%`
              }}
            >
              <span className="text-white font-bold text-sm">
                {sampleDataFallback.industryAverage}%
              </span>
            </div>
          </div>
        </div>

        {/* Top Quartile */}
        <div className="flex items-center">
          <div className="w-32 text-sm font-medium text-gray-700 dark:text-gray-300">
            Top Quartile
          </div>
          <div className="flex-1 bg-gray-200 dark:bg-gray-700 rounded-full h-8 relative">
            <div className="bg-purple-500 dark:bg-purple-400 h-8 rounded-full flex items-center justify-end pr-3 w-full">
              <span className="text-white font-bold text-sm">
                {sampleDataFallback.topQuartile}%
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-slate-50 dark:bg-slate-800 p-6 rounded-lg border border-slate-200 dark:border-slate-700">
        <h4 className="font-semibold text-slate-800 dark:text-white mb-2">
          📍 Current Position
        </h4>
        <p className="text-2xl font-bold text-slate-700 dark:text-slate-300">
          {displayData.currentPercentile}th percentile
        </p>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
          {displayData.isRealAnalysis
            ? 'Based on professional analysis model'
            : 'Based on 150+ Food & Beverage facilities'}
        </p>
        {displayData.isRealAnalysis && (
          <p className="text-xs text-emerald-600 dark:text-emerald-400 mt-1">
            ✓ Real calculation
          </p>
        )}
      </div>

      <div className="bg-emerald-50 dark:bg-emerald-900/20 p-6 rounded-lg border border-emerald-200 dark:border-emerald-700">
        <h4 className="font-semibold text-emerald-800 dark:text-emerald-300 mb-2">
          🎯 Post-Implementation
        </h4>
        <p className="text-2xl font-bold text-emerald-700 dark:text-emerald-400">
          {displayData.improvedPercentile}th percentile
        </p>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
          Projected with full implementation
        </p>
        {displayData.isRealAnalysis && (
          <p className="text-xs text-emerald-600 dark:text-emerald-400 mt-1">
            ✓ Real projection
          </p>
        )}
      </div>
    </div>
  </div>
);

export default BenchmarkComparison;


